import { useMemo } from 'react';
import PropTypes from 'prop-types';

import { BRIEF_TYPE } from 'src/data/brief';
import { GENERATION_TOOL } from 'src/data/generationTool';
import { PROJECT_TYPE } from 'src/data/project';

import { BriefFormView } from './BriefFormView';
import { VIEW_MODE } from './const';
import { DataContext } from './context';

export const BriefForm = ({
  className,
  viewMode,
  projectType,
  briefType,
  generationTool,
  content,
  onContentChange,
  onFieldFocus,
  onFieldBlur,
  errors,
  disabled,
  limitMultilineMaxRows,
}) => {
  const contextValue = useMemo(
    () => ({
      viewMode,
      projectType,
      briefType,
      generationTool,
      limitMultilineMaxRows,
    }),
    [viewMode, projectType, briefType, generationTool, limitMultilineMaxRows]
  );

  return (
    <DataContext.Provider value={contextValue}>
      <BriefFormView
        className={className}
        content={content}
        onContentChange={onContentChange}
        onFieldFocus={onFieldFocus}
        onFieldBlur={onFieldBlur}
        errors={errors}
        disabled={disabled}
      />
    </DataContext.Provider>
  );
};

BriefForm.propTypes = {
  className: PropTypes.string,
  viewMode: PropTypes.oneOf(Object.values(VIEW_MODE)),
  projectType: PropTypes.oneOf(Object.values(PROJECT_TYPE)),
  briefType: PropTypes.oneOf(Object.values(BRIEF_TYPE)),
  generationTool: PropTypes.oneOf(Object.values(GENERATION_TOOL)),
  content: PropTypes.shape(),
  onContentChange: PropTypes.func.isRequired,
  onFieldFocus: PropTypes.func,
  onFieldBlur: PropTypes.func,
  errors: PropTypes.shape(),
  disabled: PropTypes.bool,
  limitMultilineMaxRows: PropTypes.bool,
};

BriefForm.defaultProps = {
  className: '',
  viewMode: VIEW_MODE.editing,
  projectType: null,
  briefType: null,
  generationTool: null,
  content: null,
  onFieldFocus: null,
  onFieldBlur: null,
  errors: null,
  disabled: false,
  limitMultilineMaxRows: false,
};
